import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

const FaqPreview = () => (
  <section className="bg-background-100">
    <div className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="font-label text-xs tracking-[0.28em] text-primary-600">常见问题</p>
          <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            关于考古坞，你可能想问
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            旧料从哪来、能不能撤稿、为什么有些名字只写姓氏，都在这里说清楚了。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-secondary-600"
          >
            查看全部问答
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={faqs.slice(0, 5)} />
        </div>
      </div>
    </div>
  </section>
);

export default FaqPreview;